import styled from '@emotion/styled'
import { css } from '@emotion/react'
import tw from 'twin.macro'
import { Collapsible } from '#src/products/components/collapsible-section'
import { CollapsibleButton } from '#src/products/components/collapsible-section/styles'

const linkStyle = css`
  ${tw`
    w-full px-5 lg:px-3 no-underline text-grey-700
    hover:text-pretRed-700 focus:text-pretRed-700
  `}
  &:focus {
    ${tw`pret-outline outline-compact shadow-none`}
  }
  &[aria-current='true'] {
    ${tw`font-bold`}
  }
`

const sharedStyle = css`
  ${linkStyle}
  ${tw`leading-6 text-left text-lg py-3 lg:py-2`}
`

export const SubMenu = styled('ul')`
  ${tw`m-0 pb-2`}
`

export const SubMenuItem = styled('li')``

export const SubMenuLink = styled('a')`
  ${linkStyle}
  ${tw`inline-block leading-8`}
`

export const SubMenuButton = styled(Collapsible.Button)`
  ${sharedStyle}
`

export const TitleLink = styled(CollapsibleButton)`
  ${sharedStyle}
  &[aria-current='true'] {
    ${tw`text-pretRed-700`}
  }
`
